import React from "react";
import { RepositoryViewModel } from "../types";
import RepositoryListRow from "./RepositoryListRow";

interface RepositoriesListProps {
  repositories: RepositoryViewModel[];
  onToggleFavorite: (repo: RepositoryViewModel) => void;
  onOpenRepository: (repo: RepositoryViewModel) => void;
}

const RepositoriesList = ({
  repositories,
  onToggleFavorite,
  onOpenRepository,
}: RepositoriesListProps) => {
  const favoriteRepositories = repositories.filter((repo) => repo.isFavorite);
  const regularRepositories = repositories.filter((repo) => !repo.isFavorite);

  const renderRows = (items: RepositoryViewModel[]) =>
    items.map((repo) => (
      <RepositoryListRow
        key={repo.id}
        repository={repo}
        onToggleFavorite={onToggleFavorite}
        onOpenRepository={onOpenRepository}
      />
    ));

  return (
    <div className="space-y-6">
      {favoriteRepositories.length > 0 ? (
        <section className="space-y-2 rounded-lg border p-3">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold">Favorites</h3>
            <span className="text-xs text-muted-foreground">{favoriteRepositories.length}</span>
          </div>
          {renderRows(favoriteRepositories)}
        </section>
      ) : null}

      {regularRepositories.length > 0 ? (
        <section className="space-y-2 rounded-lg border p-3">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold">All repositories</h3>
            <span className="text-xs text-muted-foreground">{regularRepositories.length}</span>
          </div>
          {renderRows(regularRepositories)}
        </section>
      ) : null}
    </div>
  );
};

export default RepositoriesList;
